import * as ACTION_TYPES from "../types";
var errors = require('../common/errorMessage.json');

let initialState = {
  error: false,
  message: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.ERROR:
      return {
        ...state,
        error: action.data.error,
        message: errors[localStorage.getItem("language")][action.data.name] != undefined ? errors[localStorage.getItem("language")][action.data.name].replace("{data}", action.data.data) : errors[localStorage.getItem("language")]["ServerError"] ,
      };
    case ACTION_TYPES.RESET_ERROR:
      return { ...state, error: false };
    default:
      return state;
  }
};
